import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PLACE_KEY = 'bb-last-place';
const PLACE_MAX_AGE = 1000 * 60 * 60 * 24 * 30;

let restoredThisLoad = false;
let bootHome = true;

const isRestorablePath = (path) => (
  path === '/profile'
  || path === '/about'
  || /^\/artist\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path)
);

const readPlace = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(PLACE_KEY) || 'null');
    if (!saved || typeof saved.path !== 'string') return null;
    if (!isRestorablePath(saved.path)) return null;
    if (typeof saved.at === 'number' && Date.now() - saved.at > PLACE_MAX_AGE) return null;
    return saved;
  } catch (error) {
    return null;
  }
};

const writePlace = (path) => {
  try {
    localStorage.setItem(PLACE_KEY, JSON.stringify({ path, at: Date.now() }));
  } catch (error) {
    /* private mode */
  }
};

function RouteMemory() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (restoredThisLoad) return;
    restoredThisLoad = true;

    if (location.pathname !== '/') {
      bootHome = false;
      return;
    }

    const saved = readPlace();
    if (!saved) {
      bootHome = false;
      return;
    }
    navigate(saved.path, { replace: true });
  }, [location.pathname, navigate]);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/') {
      if (bootHome) return;
      writePlace('/');
      return;
    }
    if (!isRestorablePath(path)) return;
    bootHome = false;
    writePlace(path);
  }, [location.pathname]);

  return null;
}

export default RouteMemory;
